import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import { CircularProgress } from '@gapartners/ui';

interface PublicRouteProps {
  children: React.ReactNode;
}

export function PublicRoute({ children }: PublicRouteProps) {
  const { isAuthenticated, loading } = useSelector(
    (state: RootState) => state.auth
  );

  // Wait for auth state to be determined before redirecting
  if (loading) {
    return <CircularProgress />;
  }

  // Redirect authenticated users away from public routes (like login)
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
